module.exports = __webpack_public_path__ + "media/images/backto-square-one-bg-ebf667d6f962b8dda86271dbe22424ad.png";